import { createSelector } from 'reselect';

import { SuffixType } from 'constants/loanApplication';
import { getPersonFullName } from 'utils/loanApplication';

import { selectLoanApplication } from './loanApplication.selectors';
import { selectLoanChangesHistory } from './loanChangesHistory.selectors';

const selectTitleHolders = createSelector(
  selectLoanApplication,
  ({ titleHolders }) => titleHolders,
);

const selectTitleHoldersValues = createSelector(selectTitleHolders, Object.values);

export const selectExtendedTitleHolders = createSelector(
  [selectTitleHoldersValues, selectLoanChangesHistory],
  (titleHolders, loanChangesHistory) =>
    (titleHolders || []).map((titleHolder, index) => ({
      ...titleHolder,
      fullNameWithMiddleName: getPersonFullName({ ...titleHolder, isWithMiddleName: true }),
      middleName: titleHolder.middleName || '',
      suffix: titleHolder.suffix === SuffixType.NONE ? null : titleHolder.suffix,
      orderNumber: index + 1,
      isFieldsChanged: !!loanChangesHistory[titleHolder.titleHolderId],
    })),
);
